import { alpha, Chip, useTheme } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import type { MetricResult } from '../../types';

type Props = { badge: NonNullable<MetricResult['badge']> };

const toneToColor = (tone: Props['badge']['tone'], theme: Theme) => {
  switch (tone) {
    case 'success':
      return {
        border: theme.palette.success.main,
        bg: alpha(theme.palette.success.main, 0.12),
        color: theme.palette.success.dark,
      };
    case 'warning':
      return {
        border: theme.palette.warning.main,
        bg: alpha(theme.palette.warning.main, 0.12),
        color: theme.palette.warning.dark,
      };
    case 'danger':
      return {
        border: theme.palette.error.main,
        bg: alpha(theme.palette.error.main, 0.12),
        color: theme.palette.error.dark,
      };
    case 'info':
      return {
        border: theme.palette.info.main,
        bg: alpha(theme.palette.info.main, 0.12),
        color: theme.palette.info.dark,
      };
    default:
      return {
        border: theme.palette.grey[400],
        bg: alpha(theme.palette.grey[500], 0.12),
        color: theme.palette.text.secondary,
      };
  }
};

export default function StatusBadge({ badge }: Props) {
  const theme = useTheme();
  const colors = toneToColor(badge.tone, theme);
  return (
    <Chip
      size="small"
      label={badge.label}
      variant="outlined"
      sx={{
        height: 22,
        fontWeight: 600,
        fontSize: 11,
        backgroundColor: colors.bg,
        color: colors.color,
        borderColor: colors.border,
      }}
    />
  );
}
